import AppStateModel from './../../../model/appStateModel';


export default class RegionalComparisonModel {

    private static _stepContext:any;
    private static _averagesMap:any = {};

    static get averagesMap() {
        return RegionalComparisonModel._averagesMap;
    }

    static set averagesMap(value) {
        this._averagesMap = value;
    }



    static getResultsByYear(year = AppStateModel.birthday) {
        return {
            averages: RegionalComparisonModel.averagesMap ? RegionalComparisonModel.averagesMap[year] : {},
        }
    }

    static set stepContext(value) {
        RegionalComparisonModel._stepContext = value;
    }

    static get stepContext() {
        return RegionalComparisonModel._stepContext;
    }
}
